 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"dashboard~login~offer~parcel~parcels~presentation~project~settings~statistics":"dashboard~login~offer~parcel~parcels~presentation~project~settings~statistics","dashboard~offer~parcel~parcels~presentation~project~settings~statistics":"dashboard~offer~parcel~parcels~presentation~project~settings~statistics","settings":"settings","dashboard~offer~parcel~parcels~presentation~project~statistics":"dashboard~offer~parcel~parcels~presentation~project~statistics","dashboard":"dashboard","offer":"offer","parcel":"parcel","parcels":"parcels","project":"project","statistics":"statistics","presentation":"presentation","login":"login","help":"help","notFound":"notFound"}[chunkId]||chunkId) + "." + {"chunk-3e9ea788":"f1d31665","dashboard~login~offer~parcel~parcels~presentation~project~settings~statistics":"b2817ae1","chunk-e139de42":"da01adc9","dashboard~offer~parcel~parcels~presentation~project~settings~statistics":"c2b63fe2","chunk-2d0dd016":"406ef8f6","settings":"91a5a3ad","dashboard~offer~parcel~parcels~presentation~project~statistics":"7c713031","dashboard":"144a486f","offer":"2c1b79cb","parcel":"dfb6fb1b","parcels":"4baaca99","project":"f206f810","statistics":"0e68fb10","presentation":"31ca4855","login":"b06f74b8","help":"436876b7","notFound":"04c71e4b","chunk-241a2fe0":"0cdf922d","chunk-2d0a422c":"75ec9426","chunk-7b78ba9e":"454bc72a","chunk-a0d528d4":"dab4a57c","chunk-cf543598":"8d14c605","chunk-110a76eb":"ae017da9","chunk-2d0f11ad":"fa89dbbb","chunk-2d21d512":"c5c2d753","chunk-2d21da74":"5f2b4e8c","chunk-3a2b2c3c":"489ae333","chunk-4abee6c0":"4e838cd5","chunk-534af5da":"1852f5a7","chunk-ab91f584":"6557bfaa","chunk-f9fd9a9c":"c6492c0e","chunk-f5f142ea":"19efdba5","chunk-0eed3aa2":"11d95c71","chunk-2d0d72f3":"9976c03e","chunk-b864e588":"a66d8182","chunk-727b2b7e":"a6cb3b97","chunk-2d0c93a6":"0d2add07","chunk-2d21a58c":"9e500ca5","chunk-49371120":"d6fd6394","chunk-0b759c92":"9cf6a87b","chunk-7bc65e8b":"fed920e5","chunk-a987332e":"a5a62a7d","chunk-13cf17b0":"2871706e","chunk-3554734a":"a1b4cdca","chunk-f120ec20":"2621f895","chunk-2d21a36c":"deb1cb57","chunk-66d10026":"bbf1fe0c","chunk-77270c62":"bade8e62","chunk-e0965bd8":"1681b12d","chunk-f842135c":"b82d5663","chunk-0f205726":"14f0bbdc","chunk-1b88b302":"a8283ea3","chunk-2d2073aa":"dee97a85","chunk-2d0aa221":"96a11e5b","chunk-2d0c0e33":"a810cb9a","chunk-705d480a":"eee18fc3","chunk-9f2f91ce":"47773604"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-3e9ea788":1,"dashboard~login~offer~parcel~parcels~presentation~project~settings~statistics":1,"chunk-e139de42":1,"dashboard~offer~parcel~parcels~presentation~project~settings~statistics":1,"settings":1,"dashboard~offer~parcel~parcels~presentation~project~statistics":1,"dashboard":1,"offer":1,"parcel":1,"parcels":1,"project":1,"statistics":1,"presentation":1,"help":1,"notFound":1,"chunk-241a2fe0":1,"chunk-7b78ba9e":1,"chunk-a0d528d4":1,"chunk-cf543598":1,"chunk-110a76eb":1,"chunk-3a2b2c3c":1,"chunk-4abee6c0":1,"chunk-534af5da":1,"chunk-ab91f584":1,"chunk-f9fd9a9c":1,"chunk-f5f142ea":1,"chunk-0eed3aa2":1,"chunk-b864e588":1,"chunk-727b2b7e":1,"chunk-49371120":1,"chunk-13cf17b0":1,"chunk-3554734a":1,"chunk-f120ec20":1,"chunk-66d10026":1,"chunk-e0965bd8":1,"chunk-f842135c":1,"chunk-0f205726":1,"chunk-1b88b302":1,"chunk-705d480a":1,"chunk-9f2f91ce":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"dashboard~login~offer~parcel~parcels~presentation~project~settings~statistics":"dashboard~login~offer~parcel~parcels~presentation~project~settings~statistics","dashboard~offer~parcel~parcels~presentation~project~settings~statistics":"dashboard~offer~parcel~parcels~presentation~project~settings~statistics","settings":"settings","dashboard~offer~parcel~parcels~presentation~project~statistics":"dashboard~offer~parcel~parcels~presentation~project~statistics","dashboard":"dashboard","offer":"offer","parcel":"parcel","parcels":"parcels","project":"project","statistics":"statistics","presentation":"presentation","login":"login","help":"help","notFound":"notFound"}[chunkId]||chunkId) + "." + {"chunk-3e9ea788":"a1b512a8","dashboard~login~offer~parcel~parcels~presentation~project~settings~statistics":"1ad8fd6e","chunk-e139de42":"91b67af3","dashboard~offer~parcel~parcels~presentation~project~settings~statistics":"dda1e9d6","chunk-2d0dd016":"31d6cfe0","settings":"95e5f2b2","dashboard~offer~parcel~parcels~presentation~project~statistics":"72501713","dashboard":"2ecee464","offer":"48b7501a","parcel":"22fd1244","parcels":"33c62841","project":"c21619cc","statistics":"7b4204c9","presentation":"d821d36a","login":"31d6cfe0","help":"025244be","notFound":"55b6a8aa","chunk-241a2fe0":"de1d8105","chunk-2d0a422c":"31d6cfe0","chunk-7b78ba9e":"450d0eb3","chunk-a0d528d4":"c99cb418","chunk-cf543598":"f52eba8e","chunk-110a76eb":"ff53ca11","chunk-2d0f11ad":"31d6cfe0","chunk-2d21d512":"31d6cfe0","chunk-2d21da74":"31d6cfe0","chunk-3a2b2c3c":"5e65d35f","chunk-4abee6c0":"1edad741","chunk-534af5da":"c1132032","chunk-ab91f584":"90c1887b","chunk-f9fd9a9c":"6eda853a","chunk-f5f142ea":"fc1d9836","chunk-0eed3aa2":"450d0eb3","chunk-2d0d72f3":"31d6cfe0","chunk-b864e588":"174bd61b","chunk-727b2b7e":"8b21634c","chunk-2d0c93a6":"31d6cfe0","chunk-2d21a58c":"31d6cfe0","chunk-49371120":"865b9997","chunk-0b759c92":"31d6cfe0","chunk-7bc65e8b":"31d6cfe0","chunk-a987332e":"31d6cfe0","chunk-13cf17b0":"a67e048c","chunk-3554734a":"2e8180d5","chunk-f120ec20":"f921b4fd","chunk-2d21a36c":"31d6cfe0","chunk-66d10026":"5636cc4a","chunk-77270c62":"31d6cfe0","chunk-e0965bd8":"224d9c1a","chunk-f842135c":"60126f19","chunk-0f205726":"c2dd25ff","chunk-1b88b302":"c2dd25ff","chunk-2d2073aa":"31d6cfe0","chunk-2d0aa221":"31d6cfe0","chunk-2d0c0e33":"31d6cfe0","chunk-705d480a":"c2be619d","chunk-9f2f91ce":"2f4d8aa7"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
